import createSvgIcon from '../Utils/CreateSvgIcon';

export const MagnifyingGlass = createSvgIcon(
  <>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.7617 18.176C15.3144 19.3183 13.4868 20 11.4999 20C6.8055 20 2.99992 16.1944 2.99992 11.5C2.99992 6.80558 6.8055 3 11.4999 3C16.1943 3 19.9999 6.80558 19.9999 11.5C19.9999 13.4869 19.3182 15.3145 18.1759 16.7618L21.207 19.7929L19.7928 21.2071L16.7617 18.176ZM17.9999 11.5C17.9999 15.0899 15.0898 18 11.4999 18C7.91007 18 4.99992 15.0898 4.99992 11.5C4.99992 7.91015 7.91007 5 11.4999 5C15.0898 5 17.9999 7.91015 17.9999 11.5Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 12L15 12L15 11L12 11L12 8L11 8L11 11L8 11L8 12L11 12L11 15L12 15L12 12Z"
    />
  </>,
  'MagnifyingGlass',
);
